<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div v-if="docs">
      <v-row dense>
        <v-col cols="12">
          <v-text-field
            :value="docs.phone"
            disabled
            flat
            label="電話"
            outlined
            dense
            hide-details="auto"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            :value="eventTypeLabel(docs.eventType)"
            disabled
            flat
            label="事件類型"
            outlined
            dense
            hide-details="auto"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            :value="sourceLabel(docs.source)"
            disabled
            flat
            label="來源"
            outlined
            dense
            hide-details="auto"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            :value="formatDate(docs.consentTimestamp)"
            disabled
            flat
            label="同意時間"
            outlined
            dense
            hide-details="auto"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            :value="formatDate(docs.optOutTimestamp)"
            disabled
            flat
            label="拒收時間"
            outlined
            dense
            hide-details="auto"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            :value="docs.messageId || '-'"
            disabled
            flat
            label="Message ID"
            outlined
            dense
            hide-details="auto"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            :value="docs.apiVersion || '-'"
            disabled
            flat
            label="API Version"
            outlined
            dense
            hide-details="auto"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            :value="formatDate(docs.createdAt)"
            disabled
            flat
            label="建立時間"
            outlined
            dense
            hide-details="auto"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            :value="createdByName"
            disabled
            flat
            label="建立者"
            outlined
            dense
            hide-details="auto"
          />
        </v-col>
        <v-col cols="12">
          <div class="v-label theme--light mb-1" style="font-size: 12px">關聯客戶／代理</div>
          <v-chip
            v-for="(profile, index) in linkedProfiles"
            :key="profile._id || index"
            class="mr-2 mb-2"
            small
            outlined
          >
            {{ profileDisplayName(profile) }}
          </v-chip>
          <v-alert
            v-if="!linkedProfiles.length"
            type="info"
            outlined
            dense
            class="mt-1 mb-0"
          >
            沒有關聯的客戶／代理
          </v-alert>
        </v-col>
        <v-col cols="12">
          <v-textarea
            :value="rawMessageText"
            disabled
            flat
            label="原始訊息"
            outlined
            dense
            hide-details="auto"
            rows="8"
          />
        </v-col>
      </v-row>

      <v-row dense class="mt-4">
        <v-col class="d-flex">
          <v-spacer />
          <v-btn color="default" outlined @click="$emit('cancel')">關閉</v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import { crudRead } from '@/api/crud';
import { RESTFUL } from '@/data/constants';
import ApiError from '@/api/ApiError';
import moment from 'moment';

export default {
  name: 'OptLogDetailsForm',
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      docs: null,
    };
  },
  computed: {
    linkedProfiles() {
      const list = this.docs && this.docs.autocompleteProfiles;
      return Array.isArray(list) ? list.filter(Boolean) : [];
    },
    createdByName() {
      const by = this.docs && this.docs.createdBy;
      if (!by) return '-';
      if (typeof by === 'object' && by.name) return by.name;
      return String(by);
    },
    rawMessageText() {
      if (!this.docs || this.docs.rawMessage == null) return '-';
      try {
        return JSON.stringify(this.docs.rawMessage, null, 2);
      } catch (e) {
        return String(this.docs.rawMessage);
      }
    },
  },
  watch: {
    id: {
      immediate: true,
      handler() {
        this.reload();
      },
    },
  },
  methods: {
    formatDate(val) {
      if (!val) return '-';
      return moment(val).format('YYYY-MM-DD HH:mm');
    },
    sourceLabel(source) {
      if (source === 'manual') return '手動';
      if (source === 'whatsapp') return 'WhatsApp';
      return source || '-';
    },
    eventTypeLabel(eventType) {
      if (eventType === 'optIn') return '同意';
      if (eventType === 'optOut') return '拒收';
      if (eventType === 'optOutRemoved') return '移除拒收';
      return eventType || '-';
    },
    profileDisplayName(profile) {
      if (!profile || typeof profile !== 'object') return '-';
      const name = profile.name || '-';
      const phone = profile.phone || '';
      const type = profile.type || '';
      return [name, phone, type].filter(Boolean).join(' / ');
    },
    async reload() {
      if (!this.id) {
        this.docs = null;
        return;
      }
      this.loading = true;
      try {
        this.docs = await crudRead(api, RESTFUL.optLog.read, this.id, {
          populates: [
            { path: 'createdBy', select: ['name'] },
            {
              path: 'autocompleteProfiles',
              select: ['name', 'phone', 'type'],
            },
          ],
        });
      } catch (e) {
        const ae = ApiError.wrap(e);
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: ae.message,
          type: 'error',
          color: 'error',
        });
        this.docs = null;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
